var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-start",attrs:{"id":"main-layout"}},[_c('left-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNav),expression:"showNav"}]}),_c('right-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }